import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import type { ApiClient } from "./api/client";
import { createHttpApi } from "./api/http";
import { App } from "./app/App";
import { QueryCache } from "./data/cache";
import { registerServiceWorker } from "./pwa/register";
import "./styles/tokens.css";
import "./styles/app.css";

const cache = new QueryCache();
let api: ApiClient;
if (import.meta.env.DEV && import.meta.env.VITE_MOCK === "1") {
  // Dev server only: `import.meta.env.DEV` is the literal `false` in every `vite build`, so this branch and the mock chunk are
  // dropped from built bundles (build/assert-no-mock.mjs fails the build if any mock code ships).
  const { createMockApi } = await import("./mock/mockApi");
  api = createMockApi({ videoUrl: import.meta.env.VITE_MOCK_VIDEO_URL });
} else {
  api = createHttpApi({ onUnauthorized: () => cache.invalidate("me") });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App api={api} cache={cache} />
  </StrictMode>,
);

if (import.meta.env.PROD) void registerServiceWorker();
